const state = {
  OK: 0,

  INVALID_EVENT: 1,
  DB_INSERT_ENTRY: 2,
  DB_INSERT_ENTRANT: 3,
  
  EMPTY_PARAM: 11,
  
  DB_TOKEN_EMPTY: 21,
  DB_TOKEN_ENTRYSEQ: 22,
  DB_TOKEN_INSERT: 23,
  
  ENQ_NOENTRY: 31,
  ENQ_ANSWER_EXIST: 32,
  DB_INSERT_QUESTIONARY: 33,
  DB_INSERT_ANSWER: 34,
  ENQ_INVALID_TOKEN: 35,
  ENQ_UNABLE_GET_SEQ: 36,
  ENQ_EMPTY_PARAM: 37,
  
  MAIL_NOSEND: 41,
  MAIL_ADDR: 42,
  MAIL_SYSTEM: 43,
  MAIL_INVALID_TOKEN: 44,
  MAIL_TOKEN_EXPIRED: 45,
  
  UNKNOWN: 1000
}

let description = {}
description[state.INVALID_EVENT] = "不正な会場コードが指定されました。"
description[state.DB_INSERT_ENTRY] = "データベース登録エラーが発生しました。"
description[state.DB_INSERT_ENTRANT] = "データベース登録エラーが発生しました。"

description[state.EMPTY_PARAM] = "未入力の情報があります。"

description[state.DB_TOKEN_EMPTY] = "登録用一時キーのエラーです。"
description[state.DB_TOKEN_ENTRYSEQ] = "登録情報を取得できませんでした。"
description[state.DB_TOKEN_INSERT] = "登録用一時キーが無効です。"

description[state.ENQ_NOENTRY] = "登録情報を取得できませんでした。"
description[state.ENQ_ANSWER_EXIST] = "回答は既に登録されています。"
description[state.DB_INSERT_QUESTIONARY] = "データベース登録エラーが発生しました。"
description[state.DB_INSERT_ANSWER] = "データベース登録エラーが発生しました。"
description[state.ENQ_INVALID_TOKEN] = "登録用一時キーのエラーです。"
description[state.ENQ_UNABLE_GET_SEQ] = "登録用一時キーが無効です。"
description[state.ENQ_EMPTY_PARAM] = "未入力の項目があります。"

description[state.MAIL_NOSEND] = "完了連絡メールを送信できませんでした。"
description[state.MAIL_ADDR] = "完了連絡メールを送信できませんでした。"
description[state.MAIL_SYSTEM] = "完了連絡メール送信できませんでした。"
description[state.MAIL_INVALID_TOKEN] = "登録用一時キーが無効です。"
description[state.MAIL_TOKEN_EXPIRED] = "登録用一時キーの期限切れです。"

description[state.UNKNOWN] = "不明なエラーです。"

export default {
  ...state,
  desc: description
}
